<!-- 头部组件 -->
<template>
    <div class="head">
        <el-row>
            <el-col :span="1"  />
            <el-col :span="1">
                <div>
                    <img alt="ddjj logo" src="../assets/logo.png">
                </div>
            </el-col>
            <!-- <el-col :span="4" style="display: flex; align-items: flex-end;"> -->
            <el-col :span="3" style="display: flex; justify-content: center; align-items: center;">  
                <div>
                  <a style="color: #409eff; font-size: 28px; font-weight: bold;">DDJJ软件仓库</a>
                  <!-- 得力办公 -->
                </div>
            </el-col>
            <el-col :span="16" style="display: flex; justify-content: right; align-items: right;font-size:18px">
                <div class="d_v">提示：承接 软件定制开发、各种嵌入式app程序定制开发、硬件原理图设计、制作!  电话(微信)：13752105518 </div>
                <!-- <div class="d_v" > <router-link to="/about" class="router-link-active">主营业务</router-link></div>
                <div class="d_v">关于我们</div>
                <div class="d_v">企业新闻</div>
                <div class="d_v">联系我们</div> -->

                <!-- <div v-if="info == '2'" class="d_v" :class="{ class_a: true }" @click="core">主营业务</div>
                <div v-if="info != '2'" class="d_v" :class="{ class_a: false }" @click="core">主营业务</div>				 -->

            </el-col>
            <el-col :span="2"></el-col>

        </el-row>
    </div>

</template>
<style scoped>
.class_a {
    display: inline;
    line-height: 80px;
    margin-left: 40px;
    font-size: 20px;
    padding-bottom: 25px;
    color: #409eff;
    font-weight: bold;
    border-bottom: 2px solid #409eff;
}
.d_v {
    display: inline;
    line-height: 80px;
    margin-left: 40px;
    font-size: 20px;
    padding-bottom: 25px;
}
.router-link-active {
    color: black;
    text-decoration: none;
}


</style>